import styled, { css } from 'styled-components'

import { Flex } from '@/components/priority/Flex/Flex'
import { disabled } from '@/styles/disabled'

export type TooltipPlacement = 'above' | 'right' | 'bottom' | 'left'

type TooltipWrapperProps = {
  $clickable?: boolean
}

type TooltipBoxProps = {
  $placement: TooltipPlacement
  $offsetX: number
  $offsetY: number
}

export const TooltipWrapper = styled(Flex)<TooltipWrapperProps>`
  ${disabled}
  ${({ $clickable }) =>
    $clickable &&
    css`
      cursor: pointer;
    `}
`

const getPlacementStyles = (
  placement: TooltipPlacement,
  offsetX: number,
  offsetY: number,
) => {
  const hoverStyles = css`
    ${TooltipWrapper}:hover & {
      opacity: 1;
    }
  `

  switch (placement) {
    case 'above':
      return css`
        bottom: calc(100% + ${offsetY}px);
        left: 50%;
        transform: translateX(calc(-50% + ${offsetX}px));
        ${hoverStyles}
      `
    case 'bottom':
      return css`
        top: calc(100% + ${offsetY}px);
        left: 50%;
        transform: translateX(calc(-50% + ${offsetX}px));
        ${hoverStyles}
      `
    case 'left':
      return css`
        right: calc(100% + ${offsetX}px);
        top: 50%;
        transform: translateY(calc(-50% + ${offsetY}px));
        ${hoverStyles}
      `
    case 'right':
    default:
      return css`
        left: calc(100% + ${offsetX}px);
        top: 50%;
        transform: translateY(calc(-50% + ${offsetY}px));
        ${hoverStyles}
      `
  }
}

export const TooltipBox = styled(Flex)<TooltipBoxProps>`
  position: absolute;
  opacity: 0;
  transition: 0.15s;
  pointer-events: none;
  z-index: 1;

  ${({ $placement, $offsetX, $offsetY }) =>
    getPlacementStyles($placement, $offsetX, $offsetY)}
`
